import { Card, CardBody } from "reactstrap";
import { H4, LI, P, UL } from "../../../../AbstractElements";
import { PRODUCT_BRAND_DATA } from "../../../../Data/Ecommerce";

export const ShippingDetails = () => {
    return (
        <Card>
            <CardBody>
                <div className="collection-filter-block">
                    <UL className="pro-services simple-list">
                        {PRODUCT_BRAND_DATA.map((item, index) => (
                            <LI key={index}>
                                <div className="d-flex">
                                    {item.icon}
                                    <div className="flex-grow-1">
                                        <H4 className="f-w-700">{item.text}</H4>
                                        <P>{item.span}</P>
                                    </div>
                                </div>
                            </LI>
                        ))}
                    </UL>
                </div>
            </CardBody>
        </Card>
    );
};
